export const isProd = process.env.NODE_ENV === "production"

export function isProdDeploy() {
  return isProd && process.env.NODE_DEPLOY && process.env.NODE_DEPLOY === "prod"
}

const ApiVersion = "v5d0d0"

export const apiBaseUrl = isProdDeploy()
  ? `https://and-api.ghzs.com/${ApiVersion}`
  : `https://dev-and-api.ghzs.com/${ApiVersion}`

export const apiBaseWikiUrl = isProdDeploy()
  ? `https://api-wiki-game.ghzs.com/v1d0`
  : `https://dev-api-wiki-game.ghzs.com/v1d0`

export const apiBaseUrlToolKit = isProdDeploy()
  ? `https://and-api.ghzs.com/v5d0d0`
  : `https://dev-and-api.ghzs.com/v5d0d0`

export const apiBaseUrlV5_5 = isProdDeploy()
  ? `https://and-api.ghzs.com/v5d5d0`
  : `https://dev-and-api.ghzs.com/v5d5d0`

export const createArticleLink = id => {
  return isProdDeploy()
    ? `https://m.ghzs666.com/article/${id}#/`
    : `https://dev-bbs-mobile.ghzs.com/article/${id}#/`
  // : `https://static-web.ghzs.com/ghzs_forum_dev/android-article.html?${id}.html#/`
}

export const apiApp = isProdDeploy()
  ? `https://app-api.ghzs.com`
  : `https://dev-app-api.ghzs.com`

export enum TLocalStorageTypes {
  "CLICKEDTOOLS" = "CLICKEDTOOLS"
}
